import { render, staticRenderFns } from "./bidWinAnnouncement.vue?vue&type=template&id=337ca397&scoped=true"
import script from "./bidWinAnnouncement.vue?vue&type=script&lang=js"
export * from "./bidWinAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./bidWinAnnouncement.vue?vue&type=style&index=0&id=337ca397&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337ca397",
  null
  
)

export default component.exports